import React from 'react';
import { Col, Container, Row } from 'reactstrap';
//Import Breadcrumb
import Breadcrumbs from '../../components/Common/Breadcrumb';
import CustomSubscriptionType from './SubscriptionTable';

export default function SubscriptionList() {
  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <Breadcrumbs
            title='Dictionary'
            breadcrumbItem='Subscription Plans'
          />
          <Row>
            <Col className='col-12'>
              <CustomSubscriptionType />
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
}
